<div #gridContainer style="padding-top: 1px">
  @for (row of rows(); track rowIdx; let rowIdx = $index) {
    <div class="venn-dashboard__row">
      @for (card of row; track card.notation; let colIdx = $index) {
        <button
          type="button"
          class="venn-dashboard__card"
          [class.venn-dashboard__card--active]="activeIndex() === globalIndex(rowIdx, colIdx)"
          [attr.aria-pressed]="activeIndex() === globalIndex(rowIdx, colIdx)"
          [attr.aria-label]="card.description + ': ' + card.notation"
          (click)="activeIndex.set(activeIndex() === globalIndex(rowIdx, colIdx) ? null : globalIndex(rowIdx, colIdx))"
        >
          <dojo-venn-diagram [params]="card.params" [display]="displayConfig" />
          <div class="venn-dashboard__notation" [innerHTML]="card.notationHtml"></div>
          <div class="venn-dashboard__description">{{ card.description }}</div>
        </button>
      }
    </div>

    @if (activeRowIndex() === rowIdx && activeCard(); as card) {
      <div class="venn-dashboard__detail-panel" [style.width.px]="activeRowWidthPx()">
        <div class="venn-dashboard__detail-arrow" [style.left.px]="arrowLeftPx()"></div>

        <div class="venn-dashboard__detail-header">
          <span [innerHTML]="card.notationHtml"></span>
          <span class="venn-dashboard__detail-separator">&mdash;</span>
          <span>{{ card.description }}</span>
        </div>

        <div class="venn-dashboard__detail-explanation">{{ card.explanation }}</div>

        <div class="venn-dashboard__detail-example">
          <span class="venn-dashboard__detail-example-label">Example:</span>
          <span class="venn-dashboard__detail-example-content" [innerHTML]="card.exampleHtml"></span>
        </div>
      </div>
    }
  }
</div>
